/* eslint-disable no-console */
import React from 'react';
import { hot } from 'react-hot-loader/root';
import StoreProvider from './utils/store';
import Form from './modules/form/form';
import 'bootstrap/dist/css/bootstrap.min.css';
import './app.css';

function App(props) {
  const { calcData } = { ...props };

  return (
    <StoreProvider>
      <Form calcData={calcData} />
    </StoreProvider>
  );
}

export default hot(App);
